import type { FC } from 'react';
import { Modal } from 'antd';
import close from '../../assets/RoundedClose.svg';
import '../../components/Modals/Modals.scss';
import './ScoreCardCompletedModal.scss';

export type ScoreCardCompletedModalProps = {
    open: boolean;
    onClose: () => void;
    /** Primary — proceed to the scorecard step */
    onConfirmSubmit: () => void;
    supplierName: string;
    evaluatorName: string;
};

export const ScoreCardCompletedModal: FC<ScoreCardCompletedModalProps> = ({
    open,
    onClose,
    onConfirmSubmit,
    supplierName,
    evaluatorName
}) => (
    <Modal
        className="modal-modal score-card-completed-modal"
        wrapClassName="score-card-completed-modal-wrap"
        open={open}
        footer={null}
        closable
        centered
        destroyOnClose
        width={672}
        onCancel={onClose}
        closeIcon={<img src={close} alt="" />}
        maskClosable
    >
        <div className="score-card-completed-modal__shell">
            <div className="score-card-completed-modal__top">
                <h2 className="score-card-completed-modal__title">Scorecard Already Submitted</h2>
            </div>

            <div className="score-card-completed-modal__body">
                <p className="score-card-completed-modal__lead">
                    A scorecard for {supplierName} has already been submitted under the name {evaluatorName}.
                </p>
                <p className="score-card-completed-modal__muted">
                    You may resubmit the scorecard. Your previous submission will be replaced.
                </p>
            </div>

            <div className="score-card-completed-modal__footer">
                <button
                    type="button"
                    className="score-card-completed-modal__btn score-card-completed-modal__btn--ghost"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="score-card-completed-modal__btn score-card-completed-modal__btn--accent"
                    onClick={onConfirmSubmit}
                >
                    Submit New Evaluation
                </button>
            </div>
        </div>
    </Modal>
);
